/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileGetRequest
 */
export interface FxIdWebFeaturesProfileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileGetRequest
     */
    Game?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetRequest(value: object): value is FxIdWebFeaturesProfileGetRequest {
    return true;
}

export function FxIdWebFeaturesProfileGetRequestFromJSON(json: any): FxIdWebFeaturesProfileGetRequest {
    return FxIdWebFeaturesProfileGetRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileGetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileGetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'] == null ? undefined : json['Game'],
    };
}

export function FxIdWebFeaturesProfileGetRequestToJSON(json: any): FxIdWebFeaturesProfileGetRequest {
    return FxIdWebFeaturesProfileGetRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileGetRequestToJSONTyped(value?: FxIdWebFeaturesProfileGetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
    };
}

